<template>
  <el-dialog class="wx-oper-confirm" title="开标验证" width="600px" :visible.sync="dialogVisible">
    <el-row>
      <el-col :span="24" class="confirm-win-title">{{ winInfo.confirmWinTitle }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="12" class="confirm-win-weixin">
        <el-row>
          <el-col :span="24" class="confirm-win-weixin-title">
            <span>微信扫描二维码确认</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="confirm-win-weixin-qrcode">
            <canvas id="weixinConfirmOperQrCode"></canvas>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <span>{{ weixin.confirmStatus }}</span>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="12" class="confirm-win-userpwd">
        <el-row>
          <el-col :span="24" class="confirm-win-userpwd-title">
            <span>账号密码确认</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">{{ winInfo.confirmWinKey1 }}</el-col>
          <el-col :span="16">{{ winInfo.confirmWinVal1 }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="8">{{ winInfo.confirmWinKey2 }}</el-col>
          <el-col :span="16">{{ winInfo.confirmWinVal2 }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-input placeholder="用户名" v-model="userPwd.confirmUserName">
              <i slot="prefix" class="el-input__icon el-icon-date"></i>
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-input type="password" placeholder="密码" v-model="userPwd.confirmUserPwd">
              <i slot="prefix" class="el-input__icon el-icon-date"></i>
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="confirm-win-userpwd-btn" :span="24">
            <el-button type="primary" @click="confirmOperByUserPwd">确 定</el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-dialog>
</template>
<script>
import QRCode from 'qrcode';
import EventBus from '@/plugins/event-bus';
import { baseURL } from '@/plugins/axios';
import { checkUserPwd } from '@/services/user/user-service';
import { saveConfirmFlag, getConfirmStatus } from '@/services/weixin-service';
import { registWxDwz } from '@/services/short-url-service';

export default {
  name: '',
  components: {},
  filters: {},
  props: {},
  data() {
    return {
      dialogVisible: false,
      winInfo: {
        confirmWinTitle: null,
        confirmWinKey1: null,
        confirmWinVal1: null,
        confirmWinKey2: null,
        confirmWinVal2: null
      },
      weixin: {
        confirmParams: null,
        confirmStatus: null,
        storeKey: null,
        confirmUrl: null
      },
      userPwd: {
        confirmUserId: null,
        confirmUserName: null,
        confirmUserPwd: null
      }
    };
  },
  computed: {},
  watch: {},
  created() {
    // 修改规则列表
    EventBus.$on('showWeixinConfirmWindow', async (params, done) => {
      this.winInfo.confirmWinTitle = params.confirmWinTitle;
      this.winInfo.confirmWinKey1 = params.confirmWinKey1;
      this.winInfo.confirmWinVal1 = params.confirmWinVal1;
      this.winInfo.confirmWinKey2 = params.confirmWinKey2;
      this.winInfo.confirmWinVal2 = params.confirmWinVal2;

      this.weixin.confirmParams = params.wxConfirmParams;

      this.userPwd.confirmUserId = params.wxConfirmParams.confirmUserId;

      this.initWxConfirmQrCode();

      this.dialogVisible = true;
    });

    EventBus.$on('closeWeixinConfirmWindow', () => {
      this.dialogVisible = false;
    });
  },
  mounted() {},
  methods: {
    async initWxConfirmQrCode() {
      try {
        let { data } = await saveConfirmFlag(this.weixin.confirmParams);
        if (data.returnCode === '01') {
          this.weixin.storeKey = data.storeKey;
          this.registWxDwz();
        } else {
          this.$message.error('初始化微信确认二维码失败！');
        }
      } catch (err) {
        this.$message.error(err.message);
      }
    },
    async registWxDwz() {
      try {
        let params = {
          operType: 'CONFIRM',
          storeKey: this.weixin.storeKey,
          timeOut: '3600'
        };
        let { data } = await registWxDwz(params);
        if (data.returnCode === '01') {
          this.weixin.confirmUrl =
            document.location.protocol + '//' + location.host + baseURL + '/api/dwz/' + data.shortUrl;
          let weixinConfirmOperQrCode = document.querySelector('#weixinConfirmOperQrCode');
          let _this = this;
          QRCode.toCanvas(weixinConfirmOperQrCode, this.weixin.confirmUrl, { margin: 0, width: 220 }, function(error) {
            if (error) console.error(error);
            _this.queryConfirmStatus();
          });
        } else {
          this.$message.error('生成微信确认二维码失败！');
        }
      } catch (err) {
        this.$message.error(err.message);
      }
    },
    async queryConfirmStatus() {
      try {
        let { data } = await getConfirmStatus(this.weixin.storeKey);
        if (data.returnCode === '01') {
          if (data.confirmStatus === '1') {
            this.$message.success('用户已确认操作');
            this.$emit('confirmComplete', { storeKey: this.weixin.storeKey });
            this.dialogVisible = false;
          } else if (data.confirmStatus === '0') {
            this.$message.info('用户已取消确认');
            this.dialogVisible = false;
          } else if (data.confirmStatus === '2') {
            this.$message.info('用户已扫描');
            this.queryConfirmStatus(this.weixin.storeKey);
          } else {
            this.queryConfirmStatus(this.weixin.storeKey);
          }
        } else {
          this.queryConfirmStatus(this.weixin.storeKey);
        }
      } catch (err) {
        this.$message.error(err.message);
        this.dialogVisible = false;
      }
    },
    async confirmOperByUserPwd() {
      try {
        let { data } = await checkUserPwd(
          this.userPwd.confirmUserId,
          this.userPwd.confirmUserName,
          this.userPwd.confirmUserPwd
        );
        if (data.returnCode === '01') {
          this.$emit('confirmComplete', { storeKey: this.weixin.storeKey });
        } else if (data.returnCode === '05') {
          this.$message.error(data.errorMsg);
        } else if (data.returnCode === '03') {
          this.$message.error('参数不完整');
        } else {
          throw new Error('手机号或密码错误');
        }
      } catch (err) {
        this.$message.error(err.message);
      }
    }
  },
  beforeDestroy() {
    EventBus.$off('showWeixinConfirmWindow');
    EventBus.$off('closeWeixinConfirmWindow');
  }
};
</script>
<style lang="less">
.wx-oper-confirm {
  .el-dialog__title {
    color: #fb5b3b;
    font-size: 24px;
  }
  .confirm-win-title {
    color: #a7a6a6;
    // padding: 10px 0px;
    padding-bottom: 20px;
    margin-top: -40px;
  }
  .confirm-win-weixin {
    // border-right: 1px solid #cccccc;
    padding: 10px;
    .confirm-win-weixin-title {
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      padding: 10px 0px;
    }
    .confirm-win-weixin-qrcode {
      height: 250px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .confirm-win-userpwd {
    padding: 10px;
    .confirm-win-userpwd-title {
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      padding: 10px 0px;
    }
    .confirm-win-userpwd-btn {
      text-align: right;
    }
    & > div:not(:first-child) {
      .el-col {
        padding: 10px 0px;
      }
    }
  }
}
</style>
